import React from 'react'
import classNames from 'classnames'
import './LayoutMenu.css'

const LayoutMenu = ({ children, bottom = false }) => {
  return (
    <div
      className={classNames('g-layout-menu', {
        'g-layout-menu-bottom': bottom,
      })
    }>
      {children}
    </div>
  )
}

export default LayoutMenu
